import { WeekDay } from '@cbo/shared-library';

interface WorkWeekConfig {
  workdayStartTime: string;
  workweekStartDay: WeekDay;
}

export const defaultWorkWeekConfig: WorkWeekConfig = {
  workdayStartTime: '03:00',
  workweekStartDay: WeekDay.WEDNESDAY,
};

export default defaultWorkWeekConfig;
